import React, { useState } from 'react';
import ExpandSection from 'src/components/ExpandSection';
import { DataValue, InputLabel, NoData, Spacer } from 'src/common';
import styled from 'styled-components';
import { PencilSvg } from 'src/assets/dynamicSvg';
import { AssessmentModal, ExecSummaryModal } from 'src/components/modals';
import { AssessmentQuery } from 'src/graphql/_generated';

const Item = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  user-select: none;
  cursor: pointer;

  svg {
    width: 12px;
    height: 12px;
  }
`;

interface OverviewSectionProps {
  data: NonNullable<AssessmentQuery['assessment']>;
}

export const OverviewSection: React.FC<OverviewSectionProps> = ({ data }) => {
  const [isExecSummaryModalOpen, setIsExecSummaryModalOpen] = useState(false);
  const [isAssessmentModalOpen, setIsAssessmentModalOpen] = useState(false);

  return (
    <>
      {isAssessmentModalOpen && <AssessmentModal id={data.id} onClose={() => setIsAssessmentModalOpen(false)} />}
      {isExecSummaryModalOpen && (
        <ExecSummaryModal
          assessmentId={data.id}
          executiveSummary={data.executiveSummary}
          onClose={() => setIsExecSummaryModalOpen(false)}
        />
      )}
      <ExpandSection title="OVERVIEW" sectionId="assessment_overview" defaultOpen={false}>
        <Item onClick={() => setIsAssessmentModalOpen(true)}>
          <InputLabel weight={600}>ASSESSMENT SCOPE</InputLabel>
          <PencilSvg />
        </Item>
        <div />
        {data.description ? (
          <DataValue px={14} weight={500} style={{ whiteSpace: 'pre-line' }}>
            {data.description}
          </DataValue>
        ) : (
          <NoData />
        )}
        <Spacer $px={16} />
        <Item onClick={() => setIsExecSummaryModalOpen(true)} data-cy="exec-summary-button">
          <InputLabel weight={600}>EXECUTIVE SUMMARY</InputLabel>
          <PencilSvg />
        </Item>
        <div />
        {data.executiveSummary ? (
          <DataValue px={14} weight={500} style={{ whiteSpace: 'pre-line' }}>
            {data.executiveSummary}
          </DataValue>
        ) : (
          <NoData />
        )}
      </ExpandSection>
    </>
  );
};
